import React from 'react';

interface InputProps {
  className?: string;
  type?: 'text' | 'password' | 'email' | 'number' | 'url';
  value: string;
  placeholder?: string;
  onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange?: (value: string) => void;
  style?: React.CSSProperties;
  isLoading?: boolean;
  disabled?: boolean;
}

export const Input: React.FC<InputProps> = ({
  className = '',
  type = 'text',
  value = '',
  placeholder = '',
  onKeyUp,
  onChange,
  style = {},
  isLoading = false,
  disabled = false
}) => (
  <input
    className={className || `input ${isLoading ? 'input-loading' : ''}`}
    type={type}
    value={value}
    placeholder={placeholder}
    onKeyUp={onKeyUp}
    disabled={disabled}
    onChange={(e) => onChange?.(e.target.value)}
    style={{
      fontFamily: 'Montserrat Regular',
      boxShadow: 'none',
      boxSizing: 'border-box',
      borderRadius: '8px',
      border: '1px solid var(--grey-20,#C9CBCF)',
      outline: 'none',
      height: '38px',
      width: '100%',
      padding: 8,
      backgroundColor: disabled ? '#F9FAFB' : '#FFF',
      ...style
    }}
  />
);
